import { render, staticRenderFns } from "./BenefitCard.vue?vue&type=template&id=7aee0a52&scoped=true"
import script from "./BenefitCard.vue?vue&type=script&lang=js"
export * from "./BenefitCard.vue?vue&type=script&lang=js"
import style0 from "./BenefitCard.vue?vue&type=style&index=0&id=7aee0a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aee0a52",
  null
  
)

export default component.exports